<template>
    <v-tooltip aria-label="Подсказка о качестве" position="bottom">
        <template v-slot:activator="{ props }">
          <component v-bind="props" :is="quality_icon" class="icon__custom icon__custom__quality" :class="quality_class" />
        </template>
        <span><noindex>{{ quality_text }}</noindex></span>
    </v-tooltip>
</template>

<script>

export default {
  name: "QualityIcon",
}

</script>

<script setup>

import IconQualityLow from "./IconQualityLow.vue";
import IconQualityMedium from "./IconQualityMedium.vue";
import IconQualityHigh from "./IconQualityHigh.vue" ;

const pr = defineProps(['quality', 'offer_id']);

let quality, quality_icon, quality_class, quality_text;

if (typeof pr.quality == 'number' || typeof pr.quality  == 'string') quality = pr.quality
else quality = pr.quality[0]


switch (quality) {
  case 1:
  case 'низкая уровень':
  case 'низкое уровень':
  case "эконом":
    quality_icon = IconQualityLow; 
    quality_class = 'icon__custom__quality__low'; 
    quality_text = 'Эконом'; 
    break;
  case 2:
  case 'средняя уровень':
  case 'среднее уровень':
  case "стандарт":
    quality_icon = IconQualityMedium; 
    quality_class = 'icon__custom__quality__medium'; 
    quality_text = 'Стандарт'; 
    break;
  case 3:
  case 'высокая уровень':
  case 'высокое уровень':
  case "премиум":
    quality_icon = IconQualityHigh; 
    quality_class = 'icon__custom__quality__high'; 
    quality_text = 'Премиум'; 
    break;
  default: 
    console.error('not parsed', pr.quality, pr.offer_id);
}

</script>